export const TreballadorItem = (props) => {
  return (
    <div>
      <img str="" alt="avatar"></img>
      <div>Prova</div>
      <div></div>
    </div>
  );
};
